/* 项目详情 */
export const webObject = `query webObject($id: ID! = 1){
  webObject(id: $id){
    id
    typeName
    ObjImage{
      url
    }
    logo{
      url
    }
    objectName
    objectSubtitle
    objectIntroduction
    about
    videoUrl
    videoDesc
    topImg{
      url
    }
    botImg{
      url
    }
    videoBackground{
      url
    }
    bannerImg{
		  url
    }
    bannerColor
    webBannerItems{
      lab
      num
      icon{
        url
      }
    }
    platColor
    platIsOpen
    platTitle
    platSubTitle
    platEnTitle
    playBgImg{
      url
    }
    platform{
      title
      subtitle
      icon{
        url
      }
      rwm{
        url
      }
      LableTree{
        id
        title
        subtitle
        icon{
          url
        }
        content{
          id
          title
          url
          subTitle
          file{
            url
          }
        }
      }
    }
    modular{
      id
      title
      subTitle
      bgColor
      bgImg{
        url
      }
      file{
        url
      }
      url
    }
    skillTitle
    skillEntitle
    skillSubTitle
    webSkillModular{
      id
      title
      color
      content{
        title
        desc
      }
      icon{
        url
      }
      image{
        url
      }
    }
    program{
      title
      subTitle
      desc
      AboutImage{
        id
        title
        about
        image{
        url
      }
      }
      bgColor
      bgImg{
        url
      }
    }
    classTitle
    classEnTitle
    classList{
      id
      title
      subTitle
      desc
    }
    actionlabel
    actionImg{
      url
    }
    suitPersonTitle
    suitPersonSubTitle
    suitPersonEnTitle
    suitPersonBgColor
    suitPersonItems{
      lab
      num
      icon{
        url
      }
    }
    teachModleTitle
    TeachEnTitle
    teachBgColor
    teachBgImg{
      url
    }
    teacheres{
      id
      name
      quarters
      headerImage {
        url
      }
      details
      isPublic
      sortNum
    }
    teachBgColor
    teachBgImg{
        url
      }
  }
}`